import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import { getEnumValueByKey } from '@/Infrastructure/Utilities';
import RenderHeader from '@components/DataGrid/RenderHeader';
import Leg from '../Cells/Leg';
import { LegStatus } from '@api/Trinium/types';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

const headerDisplayName = 'Leg';

const legDefinition: GridColDefExtended<DispatchLeg> = {
  field: 'Leg',
  minWidth: 155,
  width: 155,
  headerName: 'Status|||isBulk|||isHazmat|||isLive|||isOverweight',
  headerDisplayName,
  renderHeader: () => (
    <RenderHeader
      primaryText={headerDisplayName}
      secondaryText='Statuses'
    />
  ),
  renderCell: ({ row, colDef }) => (
    <Leg
      row={row}
      colDef={colDef}
    />
  ),
  disableReorder: true,
  /** Every board leads with this column, so the columns panel offers it as a locked, disabled toggle */
  hideable: false,
  getApplyQuickFilterFn: (value: string) => {
    return (_, row): boolean =>
      applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
        const { legStatus, isBulk, isHazmat, isLive, isOverweight } = row;
        return (
          (isBulk && caseInsensitiveIncludes(value, 'bulk')) ||
          (isHazmat && caseInsensitiveIncludes(value, 'hazmat')) ||
          (isOverweight && caseInsensitiveIncludes(value, 'overweight')) ||
          (isLive && caseInsensitiveIncludes(value, 'live')) ||
          caseInsensitiveIncludes(value, getEnumValueByKey(LegStatus, legStatus))
        );
      });
  },
  valueGetter: (_, row: DispatchLeg) =>
    `${row.legStatus}|||${String(Boolean(row.isBulk))}|||${String(row.isHazmat)}|||${String(Boolean(row.isLive))}|||${String(
      Boolean(row.isOverweight)
    )}`,
  sortable: true,
  sortComparator: (v1, v2) => {
    if (typeof v1 === 'string' && typeof v2 === 'string') {
      const v1LegStatus = v1.split('|||')[0];
      const v2LegStatus = v2.split('|||')[0];

      if (v1LegStatus > v2LegStatus) {
        return 1;
      } else if (v1LegStatus < v2LegStatus) {
        return -1;
      }
    }

    return 0;
  }
};
export default legDefinition;
